import { memo, type FC } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Media } from '../../../../../theme/Media.tsx';
import { TableCell } from '../TableCell/index.tsx';
import { TableCellContentType } from '../TableCell/types.ts';
import { TableRow } from '../TableRow/index.tsx';
import { TableRowRole } from '../TableRow/types.ts';
import { ClickableTitle, TableCellGroupHeader } from './styled.ts';
import type { TableGroupProps } from './types.ts';

export const TableGroup: FC<TableGroupProps> = memo(function TableGroup({
  children,
  className,
  title,
  titleOnClick,
  tag,
  actions,
  withTopMargin,
  withBottomMargin,
}) {
  const isMobile = useMediaQuery({ query: Media.xsMax });

  return (
    <>
      {(!isMobile || withTopMargin) && (
        <TableRow rowRole={TableRowRole.SPACER}>
          <TableCell contentType={TableCellContentType.SPACER} fullRow />
        </TableRow>
      )}
      <TableRow className={className} rowRole={TableRowRole.GROUP_HEADER}>
        <TableCell contentType={TableCellContentType.GROUP_HEADER} fullRow>
          <TableCellGroupHeader $complexTitle={Boolean(actions) || Boolean(tag)}>
            {titleOnClick ? <ClickableTitle onClick={titleOnClick}>{title}</ClickableTitle> : title} {tag} {actions}
          </TableCellGroupHeader>
        </TableCell>
      </TableRow>
      {children}
      {(!isMobile || withBottomMargin) && (
        <TableRow rowRole={TableRowRole.SPACER}>
          <TableCell contentType={TableCellContentType.SPACER} fullRow />
        </TableRow>
      )}
    </>
  );
});
